import { isSupportFullScreenApi, openFullScreen, closeFullScreen, searchStringToArray } from '../../utils';
import Floor from './floor';
import API from '../api';

class Index {
    constructor() {
        this.state = window.__INITIAL_STATE__ || {};

        this.$scheme = $('.js-scheme');

        if (!this.state || !this.$scheme.length) return;

        delete window.__INITIAL_STATE__;

        this.$controlsContainer = this.$scheme.find('.js-scheme-controls');
        this.$fullScreenBtn = this.$controlsContainer.find('.js-scheme-full');
        this.$zoomInBtn = this.$controlsContainer.find('.js-scheme-zoom-in');
        this.$zoomOutBtn = this.$controlsContainer.find('.js-scheme-zoom-out');
        this.$resetBtn = this.$controlsContainer.find('.js-scheme-reset');
        this.$changeFloorBtn = this.$scheme.find('.js-scheme-floor');

        this.$searchForm = this.$scheme.find('.js-scheme-search');
        this.$categoriesForm = this.$scheme.find('.js-scheme-categories-form');
        this.$categoriesReset = this.$scheme.find('.js-scheme-categories-reset');

        this.API_SHOP_ULR = this.$categoriesForm.attr('action') || '/';
        this.API_SHOP_TYPE = this.$categoriesForm.attr('method') || 'POST';

        this.$shopSection = this.$scheme.find('.js-scheme-shops');
        this.$shopsList = this.$shopSection.find('.js-scheme-shops-list');

        this.svgContainerSelector = '.js-scheme-map';
        this.$svgContainer = $('.js-scheme-map');
        this.$body = $('.js-scheme-body');

        this._supportFullScreeApi = isSupportFullScreenApi(document.documentElement);
        this._fullScreen = false;

        this._floorMap = new Map();

        this.MAX_MS_CLICK_DELAY = 300;
        this._initialShopFlag = false;

        this.API = new API();

        this._floorIdsToSet();
        this.init();
    }

    get currentFloor() {
        const currentId = this.currentFloorId;
        return this._floorMap.get(currentId) || null;
    }

    get currentFloorId() {
        return this._floorMap.get('currentId');
    }

    _changeFloorClickHandler = e => {
        e.preventDefault();

        const $btn = $(e.currentTarget);

        if ($btn.hasClass('is-active')) return;

        const floorId = $btn.data('floor-id');
        const floorData = this.state.floors && this.state.floors[floorId];

        if (floorData) {
            this._changeTab(floorId);

            this.setFloor({
                id: floorId.toString(),
                svg: floorData.svg
            });
        }
    };

    _changeTab(id) {
        const $filteredTab = this.$changeFloorBtn.filter(`[data-floor-id=${id}]`);

        if (!$filteredTab.length || $filteredTab.hasClass('is-active')) return;

        this.$changeFloorBtn.removeClass('is-active');
        $filteredTab.addClass('is-active');
    }

    _floorIdsToSet() {
        const floors = this.state.floors;

        Object.entries(floors).forEach(([ key, data ]) => {
            const { ids } = data;

            if (!Array.isArray(ids)) return;

            const idsSet = new Set();
            ids.forEach(id => idsSet.add(id));

            floors[key].ids = idsSet;
        });
    }

    _renderCategories(categories) {
        const categoriesKeys = Object.values(categories);

        if (!categoriesKeys.length) return null;

        const html = categoriesKeys.sort((a, b) => a.title.localeCompare(b.title)).map(item => {
            const { title, slug } = item;

            return (
                `<label class="tag-list__item">
                  <input type="checkbox" class="tag-list__checkbox" name="category" value="${slug}">
                  <span class="tag tag_red tag_sm">${title}</span>
                </label>`
            );
        });

        this.$categoriesForm.html(html);
    };

    fullScreenToggle() {
        if (!this._supportFullScreeApi) return;

        const element = this.$body[0];

        if (!element && element.length) return;

        if (this._fullScreen) {
            closeFullScreen(element);
            this._fullScreen = false;
        } else {
            openFullScreen(element);
            this._fullScreen = true;
        }
    }

    _fullScreenBtnHandler = e => {
        e.preventDefault();

        this.fullScreenToggle();
    };

    _zoomInBtnHandler = e => {
        e.preventDefault();
        this.currentFloor.zoomIn();
    };

    _zoomOutBtnHandler = e => {
        e.preventDefault();
        this.currentFloor.zoomOut();
    };

    _resetHandler = e => {
        e.preventDefault();
        this.currentFloor.reset();
    };

    resetCategories = e => {
        e && e.preventDefault && e.preventDefault();
        this.$categoriesForm.trigger('reset');
        this.$categoriesForm.trigger('change');
    };

    _categoriesFormChangeHandler = () => {
        const data = this.$categoriesForm.serializeArray();
        const stateCategories = this.state.categories;
        const stateFloors = this.state.floors;
        let storesIds = [];

        data.forEach(({ value }) => {
            const ids = (stateCategories[value] && stateCategories[value].ids) || [];

            const currentFloorState = stateFloors[this.currentFloorId];

            if (currentFloorState && currentFloorState.ids) {
                const filteredIds = ids.filter(id => id && currentFloorState.ids.has && currentFloorState.ids.has(id));
                storesIds.push(...filteredIds);
            }
        });

        this.currentFloor.selectedAreas(storesIds);
        this._renderShops(storesIds);

        return false;
    };

    _svgMouseDownHandler = e => {
        e.preventDefault();
        this._timer = Date.now();
    };

    _svgMouseUpHandler = e => {
        e.preventDefault();

        const currentTimeStamp = Date.now();

        if ((currentTimeStamp - this._timer) > this.MAX_MS_CLICK_DELAY) return;

        const $item = $(e.target);
        const id = $item.prop('id');
        const isSelected = $item.hasClass('is-selected');
        const isShop = $item.prop('dataset').shop !== undefined;


        if (id && isShop && !isSelected && this.state.objects[id]) {
            const data = this.state.objects[id];

            this.currentFloor.showPopup({
                $item,
                ...data
            });
        } else {
            return this.currentFloor.destroyPopup();
        }

    };

    _renderShops(ids = []) {
        if (Array.isArray(ids) && ids.length) {
            const lowerCaseMethod = this.API_SHOP_TYPE.toLocaleLowerCase();

            this.API.get({
                method: lowerCaseMethod,
                url: this.API_SHOP_ULR,
                data: (lowerCaseMethod === 'post' ? JSON.stringify({ ids }) : `ids=${ids.join('&ids=')}`),
                processData: true
            }).then(({ html }) => {
                if (html) {
                    this.$shopsList.html(html);
                    this.$shopSection.removeClass('is-hidden');
                } else {
                    this.$shopsList.html('');
                }
            });

        } else {
            this.$shopsList.html('');
            this.$shopSection.addClass('is-hidden');
        }
    }

    _searchFormSubmitHandler = () => {
        const searchUrl = this.$searchForm.attr('action');
        const data = this.$searchForm.serialize();

        this.API.get({
            data,
            url: searchUrl
        }).then(res => {
            if (!res) return;

            const searchData = res.search;
            const curFloorId = this.currentFloorId;

            if (searchData && searchData[curFloorId] && searchData[curFloorId].ids) {
                const ids = searchData[curFloorId].ids;
                this.resetCategories();
                this.currentFloor.selectedAreas(ids);
            }
        });

        return false;
    };

    _bindHandlers() {
        if (this._supportFullScreeApi) {
            this.$fullScreenBtn.on('click', this._fullScreenBtnHandler);
        } else {
            this.$fullScreenBtn.hide(0);
        }

        this.$zoomInBtn.on('click', this._zoomInBtnHandler);
        this.$zoomOutBtn.on('click', this._zoomOutBtnHandler);
        this.$resetBtn.on('click', this._resetHandler);
        this.$categoriesReset.on('click', this.resetCategories);
        this.$categoriesForm.on('change', this._categoriesFormChangeHandler);
        this.$scheme.on('mousedown touchstart', `${this.svgContainerSelector} svg`, this._svgMouseDownHandler);
        this.$scheme.on('mouseup touchend', `${this.svgContainerSelector} svg`, this._svgMouseUpHandler);
        this.$changeFloorBtn.on('click', this._changeFloorClickHandler);
        this.$searchForm.submit(this._searchFormSubmitHandler);
    }

    showLocationOnLoad() {
        // once
        if (!this._initialShopFlag) {
            const queryUrl = location.search.split('?')[1];
            const parseQuery = searchStringToArray(queryUrl);

            if (!parseQuery.length) return;

            let queryFloor;
            let queryShopId;

            parseQuery.forEach(item => {
               if (item.name === 'floor') queryFloor = item.value;
               else if (item.name === 'id') queryShopId = item.value;
            });

            if (!queryFloor || !queryShopId) return;

            if (this.currentFloorId !== queryFloor) {
                const neededFloor = this.state.floors[queryFloor];

                if (!neededFloor) return this._initialShopFlag = true;

                this._changeTab(queryFloor);

                return this.setFloor({
                    svg: neededFloor.svg,
                    id: queryFloor
                });

            } else {
                const shopData = this.state.objects[queryShopId];

                if (shopData) {
                    const $shopItem = this.currentFloor.getShopsDOM([queryShopId]);

                    if ($shopItem && $shopItem.length) {
                        this.currentFloor.showPopup({
                            $item: $shopItem,
                            ...shopData
                        });
                    }
                }


                this._initialShopFlag = true;
            }
        }
    }

    setFloor({ svg, id }) {
        const currentFloor = this.currentFloor;

        if (currentFloor) {
            currentFloor.destroyPopup();

            if (currentFloor.$svg) Floor.transferSvgToCache(currentFloor.$svg);
        }

        const createdFloor = this._floorMap.get(id);

        //создан ли элемент класса
        if (createdFloor && createdFloor.$svg) {
            this.$svgContainer.append(createdFloor.$svg);
            createdFloor.refresh();
            this._floorMap.set('currentId', id);
            return;
        }

        new Floor({
            path: svg
        }).init(newFloor => {
            this._floorMap.set(id, newFloor);
            this._floorMap.set('currentId', id);

            this.$svgContainer.append(newFloor.$svg);
            this.currentFloor.setLogic();

            this.showLocationOnLoad();
        });
    }

    init() {
        const initialFloorId = this.$changeFloorBtn.filter('.is-active').data('floor-id');
        if (!initialFloorId) return;

        const initialFloorData = this.state.floors[initialFloorId];

        this.setFloor({
            svg: initialFloorData.svg,
            id: initialFloorId
        });

        if (this.state) {
            this.state.categories && this._renderCategories(this.state.categories);
        }

        this._bindHandlers();
    }
}

export default Index;



// WEBPACK FOOTER //
// ./components/scheme/index.js